import { Box, MenuOpenIcon, Spacing, styled } from 'ui';

export const ListBox = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing(Spacing.Large)};
  width: 100%;
`;

export const LogoBox = styled(Box)`
  align-items: center;
  display: flex;
  height: 40px;
  padding-left: ${({ theme }) => theme.spacing(Spacing.Small)};
`;

export const SidebarBox = styled(Box)`
  display: flex;
  gap: ${({ theme }) => theme.spacing(Spacing.Medium)};
  margin-top: ${({ theme }) => theme.spacing(Spacing.Medium)};
`;

export const StyledMenuOpenIcon = styled(MenuOpenIcon)`
  cursor: pointer;
`;
